import React, { Component } from 'react'

class Home extends Component {
  render () {
    return (
      <p style={{ fontSize: '6.8vw', color: '#A6817B', fontWeight: '200', textAlign: 'left', width: '100%', marginTop: '15px' }}>Sign in now to see<br/> all upcoming events!</p>
    )
  }
}

export default Home



// WEBPACK FOOTER //
// ./src/components/Home/HomePage.js